import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Modal,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import BackdropImage from "../../Images/Universal/Login.png";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

function SettingsModal({ showModal, setshowModal }) {
  // 1) Data
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const [password, setpassword] = useState(null);
  const [error, setError] = useState(false);
  const [firstLoad, setfirstLoad] = useState(false);

  // 2) useEffects

  useEffect(() => {
    if (firstLoad) {
      setfirstLoad(true);
      setError(false);
    } else {
      if (password == "1qt@x1") {
        setshowModal(false);
        setError(false);
      } else {
        setError(true);
      }
    }

    return;
  }, [password]);

  // 3) Function

  return (
    <>
      <Modal
        disableEscapeKeyDown
        open={showModal}
        onClose={() => {
          setshowModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="p-10 h-full" style={{ backgroundImage: BackdropImage }}>
          <Box sx={style} className="GlassEffectModal">
            <div className="p-10"></div>

            {/* Main section */}
            <div className="px-2">
              <div className="text-center mt-0">
                <div className=" flex justify-center items-center mt-1 ">
                  {/* <ArrowForwardIcon className="m-1" /> */}
                  <p className="text-2xl text-gray-700 font-semibold">
                    {t("Settings")}
                  </p>
                </div>
              </div>

              <div className="p-2">
                <Grid container mb={1}>
                  <>
                    <Grid container mb={1} className="justify-center ">
                      <Typography className="text-center justify-center">
                        {t(
                          "This_page_contains_settings_for_the_entire_application._Settings_can_only_be_read_by_the_administrator._Please_log_in_as_an_administrator."
                        )}
                      </Typography>
                    </Grid>
                    <Grid container className="justify-center ">
                      <TextField
                        size="small"
                        placeholder="Enter Password"
                        type={"password"}
                        value={password}
                        error={error}
                        onChange={(type) => setpassword(type.target.value)}
                      />
                    </Grid>
                  </>
                </Grid>
              </div>
            </div>

            <div className="p-3"></div>

            {/* Buttons */}
            <div className="p-4"></div>
            <Divider />
            <Grid container className="text-center">
              <Grid
                item
                xs={6}
                className="flex  Primary_Main_Background text-gray-700 justify-center items-center p-4 cursor-pointer rounded-bl-md"
                onClick={() => {
                  //cancelCall(cancelObject);
                  //setshowModal(false);
                }}
              >
                <p className="font-semibold w-full h-full hover:scale-125  ">
                  {t("Login ")}
                </p>
              </Grid>
              <Grid
                item
                xs={6}
                onClick={() => {
                  navigate("/Dashboard");
                }}
                className="flex  Primary_Dark_Background Primary_Light_Text justify-center items-center p-4 cursor-pointer rounded-br-md"
              >
                <p className="font-semibold w-full h-full hover:scale-125 ">
                  {t("Back")}
                </p>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Modal>
    </>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 550,
  borderRadius: 2,
  boxShadow: 24,
  //background: "#fff",
};

export default SettingsModal;
